import React, { useState } from 'react';
import '../styles/ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    preferredContact: 'email'
  });
  
  const [formSubmitted, setFormSubmitted] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Here you would typically send the data to your backend
    setFormSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormSubmitted(false);
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        preferredContact: 'email'
      });
    }, 3000);
  };
  
  return (
    <div className="contactus-page">
      <h1>Get in touch with us</h1>
      
      <div className="contactus-content-row">
        <div className="contactus-details">
          <p className="contact-intro">
            Need help or have a question about your water or electricity meters? Our team is here to assist you with any inquiries.
          </p>
          
          <div className="contact-cards">
            <div className="contact-card">
              <h3>Customer Support</h3>
              <div className="contactus-icon-row">
                <span className="contactus-icon email" />
                <span>support@emudata.com.au</span>
              </div>
              <div className="contactus-icon-row">
                <span className="contactus-icon phone" />
                <span>0421 190 919</span>
              </div>
              <p>Mon-Fri: 8am-6pm AEST</p>
            </div>
            
            <div className="contact-card">
              <h3>Technical Support</h3>
              <div className="contactus-icon-row">
                <span className="contactus-icon email" />
                <span>tech@emudata.com.au</span>
              </div>
              <div className="contactus-icon-row">
                <span className="contactus-icon phone" />
                <span>0421 190 920</span>
              </div>
              <p>24/7 Emergency Support</p>
            </div>
          </div>
          
          <div className="contact-address">
            <h3>Office Location</h3>
            <p>123 Water Street<br />Sydney, NSW 2000<br />Australia</p>
            <p>ABN: 12 345 678 901</p>
          </div>
        </div>
        
        <div className="contactus-form-container">
          {formSubmitted ? (
            <div className="form-success-message">
              <div className="success-icon">✓</div>
              <h3>Thank you for contacting us!</h3>
              <p>We've received your message and will get back to you shortly.</p>
            </div>
          ) : (
            <form className="contactus-form" onSubmit={handleSubmit}>
              <h2>Send us a message</h2>
              <div className="contactus-form-row">
                <input 
                  type="text" 
                  name="firstName" 
                  placeholder="First Name" 
                  value={formData.firstName} 
                  onChange={handleChange} 
                  required 
                />
                <input 
                  type="text" 
                  name="lastName" 
                  placeholder="Last Name" 
                  value={formData.lastName} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              
              <div className="contactus-form-row">
                <input 
                  type="email" 
                  name="email" 
                  placeholder="Email" 
                  value={formData.email} 
                  onChange={handleChange} 
                  required 
                />
                <input 
                  type="tel" 
                  name="phone" 
                  placeholder="Phone (optional)" 
                  value={formData.phone} 
                  onChange={handleChange} 
                />
              </div>
              
              <input 
                type="text" 
                name="subject" 
                placeholder="Subject" 
                value={formData.subject} 
                onChange={handleChange} 
                required 
              />
              
              <textarea 
                name="message" 
                placeholder="Your message" 
                rows={5} 
                value={formData.message} 
                onChange={handleChange} 
                required 
              />
              
              <div className="contact-preference">
                <p>Preferred contact method:</p>
                <div className="radio-options">
                  <label>
                    <input 
                      type="radio" 
                      name="preferredContact" 
                      value="email" 
                      checked={formData.preferredContact === 'email'} 
                      onChange={handleChange} 
                    /> 
                    Email
                  </label>
                  <label>
                    <input 
                      type="radio" 
                      name="preferredContact" 
                      value="phone" 
                      checked={formData.preferredContact === 'phone'} 
                      onChange={handleChange} 
                    /> 
                    Phone
                  </label>
                </div>
              </div>
              
              <button type="submit">Send Message</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUs; 